import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, observable } from 'aurelia-framework';
import { getAutocompleteTypeFromProductSource } from 'elements/input-autocomplete-type';
import { AsyncErrorHandler } from 'lib/ui';
import { ErpSystem } from 'models';
import { Models } from 'models/core';
import { ErpSystemService } from 'services/erp-system-service';
import { ProductService } from 'services/product-service';

@autoinject
export class ConsumptionMaterialWashingForm {
  @bindable
  @observable
  private consumptionMaterialWashing: Models.ConsumptionMaterialWashing;
  consumptionMaterialWashingChanged(consumptionMaterialWashing: Models.ConsumptionMaterialWashing) {
    if (consumptionMaterialWashing?.Id) {
      void this.setProductName(consumptionMaterialWashing.ProductId);
    }
  }

  protected articleNo = '';
  protected isDuplicate = false;

  protected inputAutocompleteType: string = 'generalproduct';
  protected erpSystemSelected = false;
  protected erpSystems: ErpSystem[] = [];

  constructor(
    private productService: ProductService,
    private erpSystemService: ErpSystemService,
    private eventAggregator: EventAggregator
  ) {
    void this.getErpSystems();
  }

  private attached() {
    this.eventAggregator.subscribe('consumptionMaterialWashingIsDuplicate', (isDuplicate) => {
      this.isDuplicate = isDuplicate;
    });
  }

  protected setProductId(event: { detail: { value: string } }) {
    const productId = Number(event.detail.value);
    this.consumptionMaterialWashing.ProductId = productId;
    void this.setProductName(productId);
  }

  @AsyncErrorHandler
  private async setProductName(productId: number) {
    if (productId) {
      const product = await this.productService.get(productId);
      this.consumptionMaterialWashing.Name = product.Name;
      this.consumptionMaterialWashing.NameEn = product.Name;
      this.consumptionMaterialWashing.NameEs = product.Name;
      this.articleNo = product.ArticleNo;
    }
  }

  protected async getErpSystems() {
    this.erpSystems = await this.erpSystemService.getAll();
  }

  protected setErpSystem(erpSystemProductSource: string) {
    this.inputAutocompleteType = getAutocompleteTypeFromProductSource(erpSystemProductSource);
    this.erpSystemSelected = true;
  }
}
